import reducerConstant from "common/reducerConstants";

const initialState = {
  timeline: [],
  timelineCount: 0,
  timelineLimit: 0,
  getTimelineTs: null,
  timelineError: null,
  loading: false,
};

const ActivityTimelineReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.getActivityTimelineRequest:
      return {
        ...state,
        loading: true,
        timelineError: null,
      };

    case reducerConstant.getActivityTimelineSuccess:
      return {
        ...state,
        loading: false,
        timelineError: null,
        getTimelineTs: Date.now(),
        timeline: action.payload.response.data || [],
        timelineCount: action.payload.response.count || 0,
        timelineLimit: action.payload.response.limit || 0,
      };

    case reducerConstant.getActivityTimelineFailed:
      return {
        ...state,
        loading: false,
        getTimelineTs: Date.now(),
        timelineError: action.payload.message,
      };

    case reducerConstant.resetActivityTimeline:
      return initialState;

    default:
      return state;
  }
};

export default ActivityTimelineReducer;
